// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3Gb1A","footer":"ModalInfo_footer__12zl9"};